import { sanitizeHtml } from "@/lib/sanitize-html";

type Props = {
  html: string | null | undefined;
  className?: string;
};

function looksLikeHtml(v: string) {
  return /<\/?(p|h[1-6]|ul|ol|li|blockquote|strong|em|a|br)\b/i.test(v);
}

function escapeHtml(s: string) {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function plainToHtml(v: string) {
  return v
    .split(/\n{2,}/)
    .map((p) => `<p>${escapeHtml(p).replace(/\n/g, "<br>")}</p>`)
    .join("");
}

/**
 * Renders sanitized HTML from the admin rich text editor. Backward-compatible
 * with existing plain-text content (paragraphs on blank lines, single newlines
 * as <br>).
 */
export function RichText({ html, className }: Props) {
  if (!html || !html.trim()) return null;
  const raw = looksLikeHtml(html) ? html : plainToHtml(html);
  const clean = sanitizeHtml(raw);
  return (
    <div
      className={`rich-text ${className ?? ""}`}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}